import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import AllGenresMobile from '@/app/[locale]/(worlds)/(worlds-landing)/genre/components/AllGenresMobile';
export default function MobileGenresSection() {
  const $ = _c(11);
  const t = useTranslations();
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0
    };
    t1 = {
      opacity: 1
    };
    t2 = {
      opacity: 0
    };
    t3 = {
      duration: 0.2,
      ease: "easeInOut"
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("worlds-landing.search.genres.title");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <h3 className="subheader-2">{t4}</h3>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <AllGenresMobile />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <motion.div key="genres" initial={t0} animate={t1} exit={t2} transition={t3} className="flex flex-col gap-2 px-4 pb-6">{t5}{t6}</motion.div>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}